"use strict";
exports.__esModule = true;
exports.getDates = exports.getRanges = exports.getPortfolioRangeConfig = exports.startOfWeek = exports.startOfDay = exports.startOfMonth = exports.startOfHour = exports.weekIncrement = exports.dayIncrement = exports.hourIncrement = void 0;
exports.hourIncrement = 60 * 60 * 1000;
exports.dayIncrement = 24 * exports.hourIncrement;
exports.weekIncrement = 7 * exports.dayIncrement;
function startOfHour(t) {
    return new Date(t.getFullYear(), t.getMonth(), t.getDate(), t.getHours());
}
exports.startOfHour = startOfHour;
function startOfMonth(t) {
    return new Date(t.getFullYear(), t.getMonth(), 1);
}
exports.startOfMonth = startOfMonth;
function startOfDay(t) {
    return new Date(t.getFullYear(), t.getMonth(), t.getDate());
}
exports.startOfDay = startOfDay;
function startOfWeek(t) {
    var d = startOfDay(t);
    return new Date(d.getTime() - d.getDay() * exports.dayIncrement);
}
exports.startOfWeek = startOfWeek;
var ranges = {
    year: {
        count: 52,
        increment: exports.weekIncrement,
        startOf: startOfWeek,
        granularityId: "WEEK"
    },
    month: {
        count: 30,
        increment: exports.dayIncrement,
        startOf: startOfDay,
        granularityId: "DAY"
    },
    week: {
        count: 7 * 24,
        increment: exports.hourIncrement,
        startOf: startOfHour,
        granularityId: "HOUR"
    },
    day: {
        count: 24,
        increment: exports.hourIncrement,
        startOf: startOfHour,
        granularityId: "HOUR"
    }
};
var getPerPortfolioRanges = function () {
    return ranges;
};
function getPortfolioRangeConfig(r) {
    return getPerPortfolioRanges()[r];
}
exports.getPortfolioRangeConfig = getPortfolioRangeConfig;
var getRanges = function () {
    return Object.keys(getPerPortfolioRanges());
};
exports.getRanges = getRanges;
function getDates(r) {
    var conf = getPortfolioRangeConfig(r);
    var t = new Date();
    var array = [t];
    t = new Date(conf.startOf(t).valueOf() - 1); // end of yesterday
    for (var d = conf.count - 1; d > 0; d--) {
        array.unshift(t);
        t = new Date(t.valueOf() - conf.increment);
    }
    return array;
}
exports.getDates = getDates;
//# sourceMappingURL=range.js.map